import type { PalmettoAccount, RepAccess } from '@/types';

export interface AppState {
  /** Raw Cognito id_token - the Authorization header for every API call. */
  jwtToken: string | null;
  /** The verified palmetto account. */
  account: PalmettoAccount | null;
  /** REP grant resolved from the account's attributes (null until verified). */
  access: RepAccess | null;
  /** Mobile side-nav drawer. */
  navOpen: boolean;
}

export const initialState: AppState = {
  jwtToken: null,
  account: null,
  access: null,
  navOpen: false,
};
